import React from "react";
import { IoChatbox } from "react-icons/io5";
import { MdPhone } from "react-icons/md";

const Contact = () => {
  return (
    <section className="contact-section">
      <button>Contact us</button>
      <h2>We'd love to hear from you</h2>
      <p>Chat with our friendly team</p>
      <img
        src="https://res.cloudinary.com/dtlf7hj7b/image/upload/v1758571416/landingPage-contact-info_nfnt5p.png"
        alt=""
      />
      <div className="contact-options">
        <div className="option">
          <IoChatbox className="icon" />
          <h3>Chat to sales</h3>
          <p>Chat to sales</p>
          <a href="mailto:sales@shophr.co">support@shophr.co</a>
        </div>
        <div className="option">
          <MdPhone className="icon" />
          <h3>Chat to sales</h3>
          <p>Chat to sales</p>
          <a href="tel:+12139529128">1 (213)-952-9128</a>
        </div>
      </div>
    </section>
  );
};

export default Contact;
